import { ComponentProps } from 'react'

export const MinusOutlined = (props: ComponentProps<'svg'>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M5.5 12.75V11.25H18.5V12.75H5.5Z" />
    </svg>
)
